import { Route, Routes } from "react-router-dom";
import RadixModule from ".";

const RadixRoute = () => {
  return (
    <Routes>
      <Route path="/:view" element={<RadixModule />} />
      <Route path="/*" element={<RadixModule />} />
    </Routes>
  );
};

export default RadixRoute;
